/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".shared-user-info-wrapper[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{min-width:5rem;font-weight:700}.boxForm[_ngcontent-%COMP%]{border:2px solid #eb904b;padding:8px}[_nghost-%COMP%]     .btn-brand{background-color:#e56c11;border-color:#e56c11;color:#fff}[_nghost-%COMP%]     .btn-brand:focus, [_nghost-%COMP%]     .btn-brand:hover{background-color:#ce610d;border-color:#ce610d;color:#fff}[_nghost-%COMP%]     .status-type-label{padding-top:5px;color:#e56c11;font-weight:bolder;font-size:1.3em;letter-spacing:1px}"];
export { styles as styles };
